<template>
  <div style="padding: 20px;">
    <a href="/admin">Admin home</a> | 
    <a href="/adminpages">Pages</a> | 
    <a href="/adminorders">Orders</a> | 
    <a href="/adminvip">VIP</a>
    <transition name="fade">
        <alert-bar v-if="msgtext" v-bind:class="msgclass">{{msgtext}}</alert-bar>
      </transition>
      <div class="mb-4">
        <input type="email" v-model="email" class="control__input"/><button @click="sendInvitation('email')">Send VIP Invitation</button>
      </div>
    <table>
      <thead>
        <th>
          Websiteid
        </th>
        <th>
          Email
        </th>
        <th>
          Remove
        </th>
      </thead>
      <tbody>
        <tr v-for="setting in settings">
          <td>
            {{setting.websiteid}}
          </td>
          <td>
            {{setting.site_mail}}
          </td>
          <td>
            <button style="background: red; color: #fff; border: 0;" @click.prevent="showModalDelete = true, selectedwebsiteid = setting.websiteid">Remove</button>
          </td>
        </tr>
      </tbody>
    </table>

    <modal v-if="showModalDelete" @close="showModalDelete = false" title="Delete site and users">
        <form @click.prevent="removeUser()">
            <p>Weet je zeker dat je deze website wil verwijderen?</p>
            <button class="button" type="submit">Ja, ik weet het zeker</button>
        </form>
    </modal>
  </div>
</template>

<script>
  import AlertBar from '../components/form/Alert.vue';
  import Loader from '../components/ui/Loader.vue';
  import Modal from '../components/modal/Modal.vue';

  import { userService } from '../services/user.service.js';
  import { authHeader } from '../services/auth-header.js';
  
  import axios from 'axios';

  export default {
    props:{
    },
    data: function (){
      return {
        selectedwebsiteid: '',
        showModalDelete: false,
        settings: {},
        email: '',
        msgclass: 'error',
        msgtext: '',
        userinfo: JSON.parse(localStorage.getItem('user'))
      }
    },
    created () {
    },
    components: {
      Modal,
      AlertBar,
      Loader
    },
    methods: {
        getCodes(){
            const requestOptions = {
              headers: authHeader()
            }

            axios.get(process.env.VUE_APP_ROOT_API+'/settings/vips', requestOptions)
            .then(response => {
                console.log(response)
                this.settings = response.data.response
            })
        },
        removeUser(){
            const requestOptions = {
              headers: authHeader()
            }

            axios.delete(process.env.VUE_APP_ROOT_API+'/users/'+this.selectedwebsiteid, requestOptions)
            .then(response => {
                this.msgtext = this.selectedwebsiteid +' has been deleted'
                this.getCodes();
                this.showModalDelete = false
            })
        },
        sendInvitation(messagetype){
            const requestOptions = {
              headers: authHeader()
            }     
        
            const data = {
              email: this.email,
              messagetype: messagetype,
              message: 'vipinvitation'
            }

            axios.post(process.env.VUE_APP_ROOT_API+'/settings/sendmessage', data, requestOptions)
            .then(
              response => {
                this.msgclass = 'success'
                this.msgtext = JSON.stringify(response.data.message)
                this.loading = false
                this.getCodes();
              },
              error => {
                let response = JSON.stringify(error)
                this.msgtext = response
                this.loading = false
              }
            )
        }
    },
    mounted(){
      this.getCodes();
    }
  }
</script>

<style lang="scss" scoped>
  table{
    border-collapse: collapse;

    th, td{
      padding: 10px 20px;
      border: 1px solid #ccc;
    }

    th{
      color: #666;
      text-transform: uppercase;
      font-weight: normal;
      font-size: .8rem;
    }
  }
</style>
